<template>
  <div class="session-busy">
    <div class="session-busy__info">
      <div class="session-busy__section session-busy__section--fourth mt-4">
        <h3 class="session-busy__section-title">ВХОД В ДЕМО КАБИНЕТ</h3>
        <p class="session-busy__section-description">
          В данный момент все демо кабинеты заняты. Попробуйте авторизоваться
          позже или оставьте свой эл. адрес и мы свяжемся с Вами.
        </p>
        <div
          class="d-flex"
          :class="{
            'has-danger': errors.has('email'),
            'mb-3': !errors.has('email'),
          }"
        >
          <input
            type="text"
            class="form-control"
            name="email"
            :placeholder="$t('login.email')"
            v-model="email"
            v-validate="'required|email'"
            autofocus
          />
          <button type="button" class="ml-4 btn btn-primary" @click="sendEmail" :disabled="isInvalid">
            отправить
          </button>
        </div>
        <div
          class="feedback has-danger mb-3 px-2 small text-left"
          v-show="errors.has('email') && email.length > 0"
        >
          <span>Введите корректный email</span>
        </div>
      </div>
      <div class="session-busy__action mt-5">
        <button type="button" class="btn btn-primary" @click="goToMain">
          Вернуться на главную
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'SessionBusy',
  data () {
    return {
      email: ''
    }
  },
  computed: {
    isInvalid () {
      return Object.values(this.fields).some(x => x.invalid)
    }
  },
  methods: {
    goToMain () {
      location.href = 'https://itprint.org'
    },
    async sendEmail () {
      try {
        await api.post.sessionBusy(this.email)
        this.$notify({
          message: 'Данные отправлены',
          type: 'success'
        })
        this.email = ''
      } catch {
        this.$notify({
          message: 'Ошибка отправки данных',
          type: 'danger'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.session-busy {
  &__info {
    max-width: 670px;
    margin: 0 auto;
    color: #fff;
  }

  &__title,
  &__section-title {
    color: #fff;
  }

  &__title {
    font-size: 15px;
    text-align: center;
  }

  &__section {
    padding-left: 15px;
    position: relative;
    box-sizing: border-box;

    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 5px;
      height: 100%;
    }

    &--fourth::before {
      background: #00bf86;
    }
  }

  &__action {
    text-align: center;

    .btn-link {
      color: #fff;
    }
  }

  .feedback {
    border-radius: 4px;
    background-color: #e74b3d;
    display: inline-block;
    color: #fff;
  }
}
</style>
